module.exports = __webpack_public_path__ + "files/d053744bb31d4e9039e57bc0246fb108.svg";